import * as actions from "./actions";

import BackendMocker from 'admin/utils/BackendMocker';
import {
   getStories,
   getFilterStories,
   getStatistics,
   createStories,
   deleteStories,
   updateStoryData,
   getStoryById,
   uploadPosterImage,
   getObjectUrl,
   getStoriesForReorder,
}  from 'admin/api/AuthApi';
import toast from "common/utils/toast";
import { updateCountStateAfterDelete } from 'admin/state/modules/resources/operations';

const StoriesMocker = new BackendMocker('stories');

export function fetchStories(params, isReorderMode) {
   return async dispatch => {
      dispatch(actions.fetchRequest());
      try {
         let resp

         if(isReorderMode) {
            resp  = await getStoriesForReorder(params.filter(it => it?.includes('sortBy')));

         } else {
            resp  = (await getStories(params)).data;
         }

         dispatch(actions.fetchRequestCompleted(resp, params?.length > 2))
      } catch (error) {
         if(error && error?.code === "ERR_CANCELED") {
            return
         }
         dispatch(actions.fetchRequestFailed());
      }
   }
}

export function getFilterBy(param, isReorderMode) {
   return async dispatch => {
      dispatch(actions.filterStories());
      try {
         let resp

         if(isReorderMode) {
            resp  = await getStoriesForReorder(param.filter(it => it?.includes('sortBy')));
         } else {
            resp  = (await getFilterStories(param)).data;
         }

         dispatch(actions.filterStoriesCompleted(resp))

      } catch (error) {
         if(error && error?.code === "ERR_CANCELED") {
            return
         }
         dispatch(actions.filterStoriesFailed());
      }
   }
}
export function getNewStories(param, isReorderMode) {
   return async dispatch => {
      dispatch(actions.newFetchRequest());
      try {
         let resp

         if(isReorderMode) {
            resp  = await getStoriesForReorder(param.filter(it => it?.includes('sortBy')));
         } else {
            resp  = (await getFilterStories(param)).data;
         }

         dispatch(actions.newFetchRequestCompleted(resp))

      } catch (error) {
         if(error && error?.code === "ERR_CANCELED") {
            return
         }
         dispatch(actions.newFetchRequestFailed());
      }
   }
}
export function fetchStatisticsData() {
   return async dispatch => {
      dispatch(actions.statisticsRequest());
      await getStatistics().then((response) => {
         dispatch(actions.statisticsRequestCompleted(response.data))
      }).catch((err) => {
         dispatch(actions.statisticsRequestFailed(err));
      })
   }
}

export function fetchEditedStory(id) {
   return dispatch => {
      dispatch(actions.fetchEditedStoryRequest());
      StoriesMocker.show(id).then(res => {
         const { data } = res;
         dispatch(actions.fetchEditedStoryCompleted(data));
      })
   }
}
// share stories
export function getImageEvent(e) {
   return dispatch => {
      dispatch(actions.fetchUploadImage(e));
   }
}

export function shareNewPost(data) {
   return async dispatch => {
      dispatch(actions.shareNewPostRequest());
      await createStories(data).then(res => {
         const { data } = res;
         dispatch(actions.shareNewPostCompleted(data));
      }).catch((error) => {
         toast.error('Please wait while your photos are uploading')
         dispatch(actions.shareNewPostFailed(error));
      })
   }
}
// delete story
export function deleteStory(id, page) {
   return async dispatch => {
      dispatch(actions.deleteStoryRequest());
      await deleteStories(id).then(res => {
         if(page === 'list'){
            dispatch(updateCountStateAfterDelete(id, 'stories'));
         }
         toast.remove('Story has been deleted')
         dispatch(actions.deleteStoryCompleted(id));
      }).catch((err) => {
         dispatch(actions.deleteStoryFailed(err));
      })
   }
}

export function setEditedStoryInput(key, value) {
   return actions.setEditedStoryInput(key, value);
}


export function getStory(id){
   return async dispatch => {
      dispatch(actions.getByIdRequest());
      await getStoryById(id).then(res => {
         dispatch(actions.getByIdCompleted(res.data));
      }).catch((err) => {
         dispatch(actions.getByIdFailed(err));
      })
   }
}

export function deleteStoryImage(id, index, src, isModal){
   return async dispatch => {
      dispatch(actions.deleteImageRequest());
      const data = { src }
      await updateStoryData(id, data).then(() => {
         toast.remove('Photo has been removed', isModal ? '0px' : '58px')
         dispatch(actions.deleteImageCompleted({ storyId: id, index }));
      }).catch((err) => {
         dispatch(actions.deleteImageFailed(err));
      })
   }
}

export function uploadPosterImageOperation(file, id) {
   return async dispatch => {
      try {
         const { data } = await uploadPosterImage(file);
         const res = await getObjectUrl([data.path], 'videos/posters/compressed-')
         const fullSrc = res.data[data.path]
         dispatch(actions.uploadPosterImageCompleted({ src: data.path, loading: false, full_src: fullSrc }));
      } catch (error) {
         toast.error('Wrong image format');
         dispatch(actions.uploadPosterImageFailed());
      }
   }
}

export function uploadCompleteOperations(id, data){
   return async dispatch => {
      try {
         dispatch(actions.uploadPosterImageCompleted(data));
      } catch (error) {
      }
   }
}
export function pinStoryOperations(id, bool){
   return async dispatch => {
      try {
         await updateStoryData(id, { 'is_pinned': !bool })
         toast.success(`Story has been ${ bool ? `unpinned` : `pinned` } `)
         dispatch(actions.pinStoryCompleted({ id, bool }));
      } catch (error) {
      }
   }
}

// Update story v2
export function updateStoryOperation(id, payload, callback, errorCallback) {
   return async dispatch => {
      try {
         await updateStoryData(id, payload)

         const { data } = await getStoryById(id)
         dispatch(actions.updateStoryCompleted(id, data))

         if(callback) {
            callback()
         }
      } catch (error) {
         if(errorCallback) {
            errorCallback(error?.response?.data)
         }
      }
   }
}
